export const getIsRent = (paymentPeriod?: string | null): boolean => {
  return paymentPeriod === 'annual' || paymentPeriod === 'monthly';
};
